class SubProduct {
  public id: number
  public price: number
  public title: string
  public supSurcharge: number
  public description: string
  public depositSurcharge: number

  constructor(subProduct: unknown) {
    this.id = subProduct.id
    this.price = subProduct.price
    this.title = subProduct.title
    this.supSurcharge = subProduct.sup_surcharge
    this.description = subProduct.description
    this.depositSurcharge = subProduct.deposit_surcharge
    // discount
  }
}

enum ProductAttributeType {
  DropDown = 1,
  CheckBox = 2,
  OptionalDropdown = 3,
}

class ProductAttributes {
  public id: number
  public optionalPlaceholder: string
  public title: string
  public type: ProductAttributeType
  public productAttributesType: string
  public subProducts: SubProduct[]

  constructor(productAttributes: unknown) {
    this.id = productAttributes.id
    this.optionalPlaceholder = productAttributes.optional_placeholder
    this.title = productAttributes.title
    this.type = productAttributes.type
    this.productAttributesType = productAttributes.type
    this.subProducts = productAttributes.sub_products.map((subProduct: unknown) => new SubProduct(subProduct))
  }
}

export {
  ProductAttributes,
}
